const converter = {}

converter.hexToBit = hex => ([hex % 256, hex >> 8])

converter.byteToHex = bit => {
  let value = Math.floor(bit / 16)

  let tab = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']

  let hi = tab[value]

  let lo = tab[bit % 16]

  return hi + lo
}

converter.wordToHex = ([lo, hi]) => {
  return '0x' + converter.byteToHex(hi) + converter.byteToHex(lo)
}

converter.versionNumber = str => {
  // e.g. str = 1.2
  const word = str.replace(/,/, '.')
    .split('.')
    .map(bit => Number(bit))
    .reverse()
  const hex = converter.wordToHex(word)
  return Number(hex)
}

window.converter = converter

export default converter
